import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
    state() {
        return {
            userName: '',
            userCode: '',
            userCompany: '',
            token: '',
            userId: ''
        }
    },
    mutations: {
        setUserName(state, val) {
            state.userName = val
        },
        setUserCode(state, val) {
            state.userCode = val
        },
        setUserCompany(state, val) {
            state.userCompany = val
        },
        setToken(state, val) {
            state.token = val
        },
        setUserId(state, val) {
            state.userId = val
        }
    }
})


// WEBPACK FOOTER //
// ./src/store/index.js